// Variant Gallery: バリアントごとに複数画像を切り替える
(function () {
  'use strict';

  var vgData = null;
  var currentVariantId = null;

  function getFilename(url) {
    return url.split('?')[0].split('/').pop().toLowerCase();
  }

  // vg-init-style はクイック追加モーダル経由で複製が挿入されることがあるため、
  // ID 決め打ちの getElementById ではなく該当する style を全て削除する
  function removeInitStyles(root) {
    Array.from((root || document).querySelectorAll('style#vg-init-style')).forEach(function (el) {
      el.remove();
    });
  }

  function parseData(script) {
    try {
      return JSON.parse(script.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  // カウンター（1/N 表示）をフィルタ後の可視スライド基準に補正する。
  // vendor slideshow.js は分子に「全スライド中の DOM index + 1」を書き、
  // 分母は Liquid が商品の全メディア数を静的に出力するため、
  // 当スクリプトが display:none にしたスライドを汲み取れない
  // slideshow-slide 自身が .product-media-container クラスを兼ねるレイアウトと、
  // 子要素に持つレイアウトの両方に対応する
  function isSlideVisible(slide) {
    if (slide.style.display === 'none') return false;
    var container = slide.matches('.product-media-container')
      ? slide
      : slide.querySelector('.product-media-container');
    return !container || container.style.display !== 'none';
  }

  function getVisibleSlides(component) {
    var slides = Array.from(component.querySelectorAll('slideshow-slide')).filter(isSlideVisible);
    // filterGallery は style.order で表示順も並び替えるため、序数は視覚順で数える
    return slides.sort(function (a, b) {
      return (parseInt(a.style.order, 10) || 0) - (parseInt(b.style.order, 10) || 0);
    });
  }

  function remapCounterCurrent(counter, component) {
    var span = counter.querySelector('[ref="current"]');
    if (!span) return;

    var slides = Array.from(component.querySelectorAll('slideshow-slide'));
    var current = null;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('aria-hidden') === 'false') {
        current = slides[i];
        break;
      }
    }
    if (!current) return;

    var ordinal = getVisibleSlides(component).indexOf(current) + 1;
    if (ordinal < 1) return;

    var text = String(ordinal);
    if (span.textContent !== text) span.textContent = text;
  }

  function syncCounters(gallery) {
    Array.from(gallery.querySelectorAll('.slideshow-controls__counter')).forEach(function (counter) {
      var component = counter.closest('slideshow-component');
      if (!component) return;

      // 分母: Liquid 出力の静的テキストノード（"/" の後ろ）を可視スライド数へ書き換え
      var visibleCount = getVisibleSlides(component).length;
      for (var i = counter.childNodes.length - 1; i >= 0; i--) {
        var node = counter.childNodes[i];
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== '') {
          node.nodeValue = String(visibleCount);
          break;
        }
      }

      remapCounterCurrent(counter, component);

      // スライド移動のたびに vendor が分子を書き戻すので、変異を監視して都度補正する。
      // 自身の書き換えでも発火するが、再計算が同値になるため収束する
      if (!counter.dataset.vgCounterSync) {
        counter.dataset.vgCounterSync = 'true';
        new MutationObserver(function () {
          remapCounterCurrent(counter, component);
        }).observe(counter, { childList: true, characterData: true, subtree: true });
      }
    });
  }

  function filterGallery(gallery, variantId, data) {
    data = data || vgData;
    if (!gallery || !variantId || !data) return;

    var id = String(variantId);
    var containers = Array.from(gallery.querySelectorAll('.product-media-container'));
    var customGallery = data.galleries && data.galleries[id];
    var dots = Array.from(gallery.querySelectorAll('.slideshow-controls__dots > li'));
    var dotParent = dots.length > 0 ? dots[0].parentElement : null;
    // ズームダイアログのサムネイル一覧（.product-media-container ではないため個別に対象化）
    var zoomThumbs = Array.from(gallery.querySelectorAll('.dialog-thumbnails-list__thumbnail'));

    if (customGallery && customGallery.length > 0) {
      // カスタムギャラリー: 全セット（デスクトップ・モバイル等）のコンテナを対象にフィルタ
      var allowed = customGallery.map(function (f) { return f.toLowerCase(); });
      var visibleSet = {};

      containers.forEach(function (el, i) {
        el.style.order = '';
        var img = el.querySelector('img');
        if (!img) { el.style.display = 'none'; return; }
        var name = getFilename(img.getAttribute('src') || '');
        var orderIdx = allowed.indexOf(name);
        if (orderIdx !== -1) {
          el.style.display = '';
          el.style.order = orderIdx;
          visibleSet[i] = true;
        } else {
          el.style.display = 'none';
        }
      });

      // ズームダイアログのサムネイルも同じ許可リスト・並び順でフィルタ
      zoomThumbs.forEach(function (el) {
        el.style.order = '';
        var img = el.querySelector('img');
        if (!img) { el.style.display = 'none'; return; }
        var name = getFilename(img.getAttribute('src') || '');
        var orderIdx = allowed.indexOf(name);
        if (orderIdx !== -1) {
          el.style.display = '';
          el.style.order = orderIdx;
        } else {
          el.style.display = 'none';
        }
      });

      // ドット更新（先頭 dots.length 個のコンテナがドットに対応）
      if (dots.length > 0) {
        var visibleDotCount = 0;
        for (var di = 0; di < dots.length; di++) {
          if (visibleSet[di]) visibleDotCount++;
        }
        var visibleDotNum = 0;
        dots.forEach(function (li, i) {
          if (visibleSet[i]) {
            li.style.display = '';
            visibleDotNum++;
            var btn = li.querySelector('button');
            if (btn) {
              btn.textContent = visibleDotNum;
              btn.setAttribute('aria-label', 'スライド ' + visibleDotNum + '/' + visibleDotCount);
            }
          } else {
            li.style.display = 'none';
          }
        });
      }

    } else {
      // フォールバック: Horizon の hide_variants 相当 (featured + 非バリアント画像のみ表示)
      var featured = ((data.variantFeatured && data.variantFeatured[id]) || '').toLowerCase();
      var attached = (data.attachedToVariant || []).map(function (f) { return f.toLowerCase(); });
      var visibleSet = {};

      containers.forEach(function (el, i) {
        el.style.order = '';
        var img = el.querySelector('img');
        if (!img) { el.style.display = ''; visibleSet[i] = true; return; }
        var name = getFilename(img.getAttribute('src') || '');
        var hide = attached.indexOf(name) !== -1 && name !== featured;
        el.style.display = hide ? 'none' : '';
        if (!hide) visibleSet[i] = true;
      });

      // ズームダイアログのサムネイルも同条件でフィルタ
      zoomThumbs.forEach(function (el) {
        el.style.order = '';
        var img = el.querySelector('img');
        if (!img) { el.style.display = ''; return; }
        var name = getFilename(img.getAttribute('src') || '');
        var hide = attached.indexOf(name) !== -1 && name !== featured;
        el.style.display = hide ? 'none' : '';
      });

      if (dots.length > 0) {
        var visibleCount2 = Object.keys(visibleSet).length;
        var visibleNum2 = 0;
        dots.forEach(function (li, i) {
          if (visibleSet[i]) {
            li.style.display = '';
            visibleNum2++;
            var btn = li.querySelector('button');
            if (btn) {
              btn.textContent = visibleNum2;
              btn.setAttribute('aria-label', 'スライド ' + visibleNum2 + '/' + visibleCount2);
            }
          } else {
            li.style.display = 'none';
          }
        });
      }
    }

    syncCounters(gallery);
  }

  function applyFilter() {
    var gallery = document.querySelector('media-gallery');
    if (gallery) filterGallery(gallery, currentVariantId);
    removeInitStyles();
  }

  // 現在チェックされている全オプション値の組み合わせからバリアントを解決する。
  // input の data-variant-id はサーバーレンダリング時点の他オプション選択を前提と
  // した値のため、fetch → morph が追いつく前に連続クリックすると古い ID を返す。
  // チェック状態はクライアントで常に最新なので、こちらを正とする
  function resolveVariantFromPicker(picker, data) {
    if (!data || !data.variantOptions) return null;

    var values = [];
    Array.from(picker.querySelectorAll('fieldset, select')).forEach(function (el) {
      if (el.tagName === 'SELECT') {
        values.push(el.value);
      } else {
        var checked = el.querySelector('input:checked');
        if (checked) values.push(checked.value);
      }
    });
    if (values.length === 0) return null;

    var ids = Object.keys(data.variantOptions);
    for (var i = 0; i < ids.length; i++) {
      var opts = data.variantOptions[ids[i]] || [];
      var matched = values.every(function (v) {
        return opts.indexOf(v) !== -1;
      });
      if (matched) return Number(ids[i]);
    }
    return null;
  }

  function observeGallery() {
    var section = document.querySelector('.shopify-section:has(media-gallery)');
    if (!section) return;

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          var g = null;
          if (node.nodeName === 'MEDIA-GALLERY') {
            g = node;
          } else if (node.querySelector) {
            g = node.querySelector('media-gallery');
          }
          if (!g) return;
          // フラッシュ防止: 挿入直後に全コンテナを非表示→フィルタで正しい状態に復元
          Array.from(g.querySelectorAll('.product-media-container')).forEach(function (c) {
            c.style.display = 'none';
          });
          filterGallery(g, currentVariantId);
        });
      });
    }).observe(section, { childList: true, subtree: true });
  }

  // バリアント切り替え時のデコード待ちをなくすため、ギャラリー画像をアイドル時間に1枚ずつ事前デコード
  function predecodeGalleryImages() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var imgs = Array.from(gallery.querySelectorAll('.product-media-container img'));

    function schedule(fn) {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(fn, { timeout: 2000 });
      } else {
        setTimeout(fn, 200);
      }
    }

    function next() {
      var img = imgs.shift();
      if (!img) return;
      var done = function () { schedule(next); };
      if (img.decode) {
        img.decode().then(done, done);
      } else {
        done();
      }
    }

    schedule(next);
  }

  function init() {
    var script = document.getElementById('vg-data');
    if (!script) return;

    vgData = parseData(script);
    if (!vgData) {
      removeInitStyles();
      return;
    }

    currentVariantId = vgData.variantId;
    applyFilter();
    observeGallery();

    if (document.readyState === 'complete') {
      predecodeGalleryImages();
    } else {
      window.addEventListener('load', predecodeGalleryImages, { once: true });
    }

    // vendor media-gallery.js は variant:update 受信時に fetch 結果の HTML で
    // ギャラリー DOM を丸ごと replaceWith する。画像の再構築で白フラッシュが出るうえ、
    // 表示制御は当スクリプトのフィルタで完結しているため差し替え自体が不要。
    // capture フェーズ（vendor のリスナーより先）で fetch 結果から media-gallery を
    // 取り除き、差し替えを無効化する
    document.addEventListener(
      'variant:update',
      function (e) {
        var detail = e.detail && e.detail.data;
        var html = detail && detail.html;
        if (!html || !html.querySelector) return;

        // 別商品への切り替え（combined listing）はギャラリー内容自体が変わるので差し替えを許可
        if (detail.newProduct) return;

        // メイン商品ギャラリー以外（商品カード・クイック追加・featured product）は対象外
        var target = e.target;
        if (target instanceof Element) {
          if (
            target.closest('product-card') ||
            target.closest('quick-add-dialog') ||
            target.closest('featured-product-information')
          ) {
            return;
          }
        }

        var newGallery = html.querySelector('media-gallery');
        if (newGallery) newGallery.remove();
      },
      true
    );

    // メイン商品ページの variant-picker を取得（カード・クイック追加・featured product を除外）
    function findMainPicker() {
      var pickers = document.querySelectorAll('variant-picker');
      for (var i = 0; i < pickers.length; i++) {
        var p = pickers[i];
        if (
          !p.closest('product-card') &&
          !p.closest('quick-add-dialog') &&
          !p.closest('featured-product-information')
        ) {
          return p;
        }
      }
      return null;
    }

    // すべての切り替えトリガーの共通入口。
    // vendor が URL やイベントに載せる variant ID は stale な data-variant-id 由来の
    // ことがあるため、常に picker のチェック状態から再解決した ID を優先し、
    // 解決できない場合のみ fallbackId を使う
    function syncVariant(fallbackId) {
      var picker = findMainPicker();
      var id = picker ? resolveVariantFromPicker(picker, vgData) : null;
      if (!id) id = fallbackId;
      if (id && id !== currentVariantId) {
        currentVariantId = id;
        applyFilter();
      }
    }

    // change イベントで同期的に切り替える最速パス。
    // vendor の variant-picker は yieldToMainThread 後の history.replaceState や
    // fetch 完了を待つため、それより早いクリック直後のタイミングで発火する
    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!(target instanceof Element)) return;
      if (!target.closest('variant-picker')) return;
      // 商品ページ内のおすすめ商品カードやクイック追加の変更ではメインギャラリーを触らない
      if (target.closest('product-card') || target.closest('quick-add-dialog')) return;

      var option = target instanceof HTMLSelectElement ? target.options[target.selectedIndex] : target;
      var fallbackId = option && option.dataset && option.dataset.variantId ? Number(option.dataset.variantId) : null;
      syncVariant(fallbackId);
    });

    // URL の ?variant= を読み取る（variant:update より早いタイミングで取得可能）
    function extractVariantIdFromUrl() {
      var id = new URLSearchParams(window.location.search).get('variant');
      return id ? Number(id) : null;
    }

    // フォールバック1: history.replaceState/pushState をパッチして URL 変化時に同期。
    // vendor が URL に書く variant ID は連続クリック時に stale なことがあるため、
    // syncVariant 経由でチェック状態からの解決を優先する
    function patchHistoryMethod(method) {
      var original = history[method];
      history[method] = function () {
        original.apply(history, arguments);
        syncVariant(extractVariantIdFromUrl());
      };
    }
    patchHistoryMethod('pushState');
    patchHistoryMethod('replaceState');

    // フォールバック2: variant:update（fetch 完了時のサーバー応答）でも同期
    document.addEventListener('variant:update', function (e) {
      var variant = e.detail && e.detail.resource;
      syncVariant(variant && variant.id ? variant.id : null);
    });
  }

  // クイック追加モーダル対応:
  // vendor の quick-add.js は商品ページの [data-product-grid-content] を丸ごとクローンして
  // モーダルへ挿入するため、custom-variant-gallery-data ブロックが出力する vg-init-style
  // （フラッシュ防止の全画像非表示スタイル）もモーダル内に持ち込まれる。
  // コレクションページ等ではメインの init() が早期 return しており誰もこのスタイルを
  // 外さないため、モーダル内のギャラリーをここでフィルタしてからスタイルを削除する。
  // モーダルは商品ごとに固有の vg-data を持つので、ページの vgData ではなく
  // モーダル内の vg-data を都度パースして使う
  function initQuickAddModal() {
    var modalContent = document.getElementById('quick-add-modal-content');
    if (!modalContent) return;

    function applyModalFilter() {
      var script = modalContent.querySelector('script#vg-data');
      var gallery = modalContent.querySelector('media-gallery');
      var data = script ? parseData(script) : null;

      if (gallery && data) {
        var picker = modalContent.querySelector('variant-picker');
        var id = picker ? resolveVariantFromPicker(picker, data) : null;
        filterGallery(gallery, id || data.variantId, data);
      }

      removeInitStyles(modalContent);
    }

    // モーダルを開くたび・バリアント更新のたびに morph でコンテンツが再構築されるため、
    // 挿入を監視して適用する。MutationObserver のコールバックは描画前のマイクロタスクで
    // 走るので、フィルタ前の全画像が一瞬見えることはない。
    // 注意: filterGallery 自身もドット更新（textContent 書き換え）で childList 変異を
    // 起こすため、無条件に反応すると無限ループする。media-gallery か vg-init-style を
    // 含む要素ノードが「追加」された時だけ反応する
    new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return false;
          if (node.nodeName === 'MEDIA-GALLERY' || node.id === 'vg-init-style') return true;
          return !!(node.querySelector && node.querySelector('media-gallery, style#vg-init-style'));
        });
      });
      if (relevant) applyModalFilter();
    }).observe(modalContent, { childList: true, subtree: true });

    // モーダル内でバリアントを切り替えた直後の最速パス（fetch 完了を待たず再フィルタ）
    modalContent.addEventListener('change', function (e) {
      var target = e.target;
      if (!(target instanceof Element) || !target.closest('variant-picker')) return;
      applyModalFilter();
    });
  }

  function setup() {
    init();
    initQuickAddModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

// メールマガジン登録:
//  - AJAX送信でリダイレクトを防ぎ、上部のinfo barで完了通知
//  - 万一ネイティブ送信でリダイレクトされた場合は、登録セクションへスクロール
// （他コードの例外に影響されないよう独立IIFEで登録）
(function () {
  'use strict';

  // 上部中央に一定時間だけ表示して自動的に消えるinfo bar
  function showSignupToast(message) {
    if (!message) return;

    var existing = document.querySelector('.signup-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'signup-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = message;
    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.classList.add('signup-toast--visible');
    });

    setTimeout(function () {
      toast.classList.remove('signup-toast--visible');
      toast.addEventListener(
        'transitionend',
        function () {
          toast.remove();
        },
        { once: true }
      );
    }, 5000);
  }

  // AJAX送信（リダイレクト回避）
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('email-signup__form')) return;

    e.preventDefault();

    var inputGroup = form.querySelector('[data-email-signup-input-group]');
    var successMsg = form.querySelector('[data-email-signup-success]');
    var btn = form.querySelector('.email-signup__button');
    var textEl = successMsg ? successMsg.querySelector('.email-signup__message-text') : null;
    var message = textEl ? textEl.textContent.trim() : '';

    if (btn) btn.disabled = true;

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'text/html' },
    })
      .then(function (response) {
        if (!response.ok) {
          if (btn) btn.disabled = false;
          return;
        }
        if (inputGroup) inputGroup.hidden = true;
        if (successMsg) {
          successMsg.removeAttribute('hidden');
          successMsg.focus();
        }
        showSignupToast(message);
      })
      .catch(function () {
        if (btn) btn.disabled = false;
      });
  });

  // ネイティブ送信でリダイレクトされて戻ってきた場合の保険:
  // サーバー側で表示された完了メッセージがあれば、その登録セクションへスクロール＋info bar表示
  function handleRedirectedSuccess() {
    var successMsg = document.querySelector('[data-email-signup-success]:not([hidden])');
    if (!successMsg) return;

    var block = successMsg.closest('.email-signup-block') || successMsg;
    block.scrollIntoView({ behavior: 'smooth', block: 'center' });

    var textEl = successMsg.querySelector('.email-signup__message-text');
    showSignupToast(textEl ? textEl.textContent.trim() : '');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleRedirectedSuccess);
  } else {
    handleRedirectedSuccess();
  }
})();


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.header-menu .menu-list__link[aria-haspopup="true"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
    });
  });

  document.querySelectorAll('.mega-menu__link--parent').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
    });
  });
});

// カード価格の「¥X,XXXから」表記ガード:
// Globoカラースウォッチ等のアプリJSがカードの .price テキストを
// バリアント価格で直接書き換えるため、サーバー側で data-price-from に
// 出力した正解テキストへ復元する（snippets/custom-price-card.liquid と対）
(function () {
  'use strict';

  function restore(el) {
    var want = el.getAttribute('data-price-from');
    if (want && el.textContent.trim() !== want) {
      el.textContent = want;
    }
  }

  function restoreAll(root) {
    (root || document).querySelectorAll('[data-price-from]').forEach(restore);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      var el = target.nodeType === Node.TEXT_NODE ? target.parentElement : target;
      if (!el || !el.closest) continue;
      var priceEl = el.closest('[data-price-from]');
      if (priceEl) {
        restore(priceEl);
      } else if (el.querySelectorAll) {
        // 追加ノード配下（無限スクロールの新規カード等）もチェック
        restoreAll(el);
      }
    }
  });

  function init() {
    restoreAll(document);
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ===== カラースウォッチ: ※注記バリアント対応(Globoアプリ + テーマvariant-picker + サブブランドページ 共通) =====
// 運用規約: 予約販売・欠品時はバリアント名に「※」で注記を付ける(例:「ブラック※9月上旬お届け予定」)。
// 名前が変わると色マッピングが外れる(Globoは円が消える/テーマはグレーにフォールバック)ため、
// ベース色名(※より前)から色を補完する。新色を追加したら COLOR_MAP にも追加すること。
// 色の定義はこの COLOR_MAP のみを正とする(custom-main-sub-brand.liquid 側では色をハードコードしない)。
// 薄色+斜線(custom.css の .swatch--restock)は「購入不可」の場合のみ。予約販売(購入可)は通常表示。
// 購入可否はテーマの data-option-available で判定する(Globo側・サブブランドページには可否情報がないため常に通常表示)。
(function () {
  'use strict';

  var COLOR_MAP = {
    'ブラック': '#121212',
    'レッド': '#e94536',
    '無塗装': '#9b9b9b'
  };

  var GLOBO_SWATCH_CLASSES = [
    'globo-border-color-swatch',
    'globo-style-circle',
    'globo-size-medium',
    'globo-border-style-double',
    'globo-border-effects-glow',
    'globo-hover-size_change-increase'
  ];

  function baseColorName(value) {
    value = (value || '').trim();
    var markerIndex = value.indexOf('※');
    return markerIndex === -1 ? value : value.slice(0, markerIndex).trim();
  }

  function colorForValue(value) {
    return COLOR_MAP[baseColorName(value)] || null;
  }

  function restockColor(input) {
    var value = (input && input.value) || '';
    if (value.indexOf('※') === -1) return null;
    return colorForValue(value);
  }

  // Globoアプリ(コレクション/一覧)のスウォッチ。色の復元のみ(購入可否情報がないため斜線は付けない)
  function applyGlobo() {
    Array.from(document.querySelectorAll('.ul-swatches-list li.swatches-options')).forEach(function (li) {
      var input = li.querySelector('input[type="radio"]');
      var label = li.querySelector('label.swatch-anchor');
      if (!input || !label || label.dataset.swatchRestored) return;
      var color = restockColor(input);
      if (!color) return;
      GLOBO_SWATCH_CLASSES.forEach(function (c) { label.classList.add(c); });
      label.dataset.swatchRestored = 'true';
      label.style.backgroundColor = color;
      label.style.fontSize = '0';
    });
  }

  // テーマ標準 variant-picker(商品ページ)のスウォッチ
  function applyVariantPicker() {
    Array.from(document.querySelectorAll('variant-picker .variant-option--swatches label.variant-option__button-label--has-swatch')).forEach(function (label) {
      var input = label.querySelector('input[type="radio"]');
      var swatch = label.querySelector('.swatch');
      if (!input || !swatch) return;
      var color = restockColor(input);
      if (!color) return;
      swatch.style.setProperty('--swatch-background', color);
      // 購入不可(欠品)のみ薄色+斜線。予約販売(available=true)は通常表示。
      // バリアント切替で可否が変わり得るため毎スキャンで付け外しする
      swatch.classList.toggle('swatch--restock', input.getAttribute('data-option-available') === 'false');
    });
  }

  // サブブランドページ(custom-main-sub-brand.liquid)のカラードット。
  // liquid側は title のみ出力し、色自体はこの COLOR_MAP から都度補完する(可否情報がないため斜線は付けない)。
  function applySubBrandDots() {
    Array.from(document.querySelectorAll('.product-color-dots .color-dot')).forEach(function (dot) {
      var color = colorForValue(dot.getAttribute('title'));
      if (!color) return;
      dot.style.backgroundColor = color;
    });
  }

  var scheduled = false;
  function scanAll() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      applyGlobo();
      applyVariantPicker();
      applySubBrandDots();
    });
  }

  function init() {
    scanAll();
    // Globoの非同期挿入と、バリアント切替時のセクション再描画(morph)の両方を拾う
    new MutationObserver(scanAll).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Globoカラースウォッチ復元: フィルター/並び替えでコレクション・検索結果の
// グリッドが Section Rendering API で再描画(morph)されると、Globoアプリが
// JSで挿入したスウォッチDOMがサーバーHTMLに含まれないため消える。
// カードに .swatches-globo が無い状態を検知したら再スキャンさせる。
(function () {
  'use strict';

  function needsRescan() {
    // morphで results-list ごと差し替えられる場合があるため毎回取り直す
    var list = document.querySelector('results-list');
    if (!list) return false;
    var cards = list.querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) {
      if (!cards[i].querySelector('.swatches-globo')) return true;
    }
    return false;
  }

  var scheduled = false;
  function rescan() {
    if (scheduled) return;
    scheduled = true;
    // morphは複数ミューテーションを連続発生させるためまとめて1回にする
    setTimeout(function () {
      scheduled = false;
      // GloboSwatchCollection.scanAll は冪等(既処理カードには重複挿入しない)
      if (window.GloboSwatchCollection && needsRescan()) {
        window.GloboSwatchCollection.scanAll();
      }
    }, 100);
  }

  function init() {
    var list = document.querySelector('results-list');
    if (!list) return;
    var root = list.closest('.shopify-section') || document.body;
    new MutationObserver(rescan).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
